import * as Yup from 'yup';

export const SignupSchema = Yup.object({
  name: Yup.string()
  .required('Name is required')
  .matches(/^[A-Za-z.\s]+$/, 'Only alphabets, dot and space are allowed')
  .min(5, 'Name must be 5 characters or more')
  .max(128, 'Name must be 128 characters or less'),
  username: Yup.string()
    .required("Username is required")
    .matches(/^[a-zA-Z0-9_]+$/, "alphanumeric and underscore allowed (no spaces).")
    .min(10, 'Username must be 10 characters or more')
    .max(256, 'Username must be 256 characters or less'),
  // phonecode: Yup.string().required('Select Country Code'),
  phone: Yup.string()
    .required('Phone number is required'),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  date_of_birth: Yup.date()
    .required('Date of birth is required')
    .max(new Date(), 'Date of birth cannot be in the future')
    .typeError('Please enter a valid date')
    .test(
      'age',
      'You must be at least 18 years old',
      function (value) {
        if (!value) return false;

        const today = new Date();
        const birthDate = new Date(value);

        // Calculate the minimum allowed DOB
        const minDate = new Date(
          today.getFullYear() - 18,
          today.getMonth(),

        );

        return birthDate <= minDate;
      }
    ),
  password: Yup.string()
    .required("Enter Password")
    .min(8, "Password must be at least 8 characters (including uppercase, lowercase, number, and special character)")
    .max(256, "Maximum 256 characters allowed")
    .matches(/[a-z]/, "At least one lowercase letter required")
    .matches(/[A-Z]/, "At least one uppercase letter required")
    .matches(/[0-9]/, "At least one number required")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "At least one special character required"),
  terms: Yup.boolean()
    .oneOf([true], 'You must accept the terms and conditions')
    .required('You must accept the terms and conditions')
});


export const LoginSchema = Yup.object({

  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: Yup.string().required("Enter Password")
});

export const ForgotPasswordSchema = Yup.object({

  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
});

export const ChangePasswordSchema = Yup.object({

  password: Yup.string()
    .required("Enter Password")
    .min(8, "Password must be at least 8 characters (including uppercase, lowercase, number, and special character)")
    .max(256, "Maximum 256 characters allowed")
    .matches(/[a-z]/, "At least one lowercase letter required")
    .matches(/[A-Z]/, "At least one uppercase letter required")
    .matches(/[0-9]/, "At least one number required")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "At least one special character required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),

});


export const OtpSchema = Yup.object({
  otp: Yup.string()
    .required('OTP is required')
    .matches(/^\d{6}$/, 'Please enter a valid 6-digit OTP')
});
